import { FC } from 'react';

interface ErrorMessageProps {
  message?: string;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <div className="w-full overflow-hidden">
      <span className="text-red-500 text-sm block overflow-hidden text-ellipsis md:max-w-[350px]">
        {message}
      </span>
    </div>
  );
};

export default ErrorMessage;
